import { ClientName } from '@enums/ClientName'

export const rewardsConfig = {
  local: {
    rewardClientNames: {
      health: 'rewards_uat__acko__health',
      car: 'rewards_uat__acko__auto',
      bike: 'rewards_uat__acko__auto',
      life: 'rewards_uat__acko__life',
      travel: 'rewards_uat__acko__travel',
      ackoDrive: 'rewards_uat__acko__ackodrive',
      ackoDriveService: 'rewards_uat__acko__ackodriveservice',
    },
    assetRewardIds: {
      [ClientName.CAR]: ['3bece3e2-9e31-4d36-99d4-93ec16969767'],
    },
  },
  master: {
    rewardClientNames: {
      health: 'rewards_uat__acko__health',
      car: 'rewards_uat__acko__auto',
      bike: 'rewards_uat__acko__auto',
      life: 'rewards_uat__acko__life',
      travel: 'rewards_uat__acko__travel',
      ackoDrive: 'rewards_uat__acko__ackodrive',
      ackoDriveService: 'rewards_uat__acko__ackodriveservice',
    },
    assetRewardIds: {
      [ClientName.CAR]: ['3bece3e2-9e31-4d36-99d4-93ec16969767'],
    },
  },
  dev: {
    rewardClientNames: {
      health: 'rewards_uat__acko__health',
      car: 'rewards_uat__acko__auto',
      bike: 'rewards_uat__acko__auto',
      life: 'rewards_uat__acko__life',
      travel: 'rewards_uat__acko__travel',
      ackoDrive: 'rewards_uat__acko__ackodrive',
      ackoDriveService: 'rewards_uat__acko__ackodriveservice',
    },
    assetRewardIds: {
      [ClientName.CAR]: ['3bece3e2-9e31-4d36-99d4-93ec16969767'],
    },
  },
  prod: {
    rewardClientNames: {
      health: 'rewards_prod__acko__health',
      car: 'rewards_prod__acko__auto',
      bike: 'rewards_prod__acko__auto',
      life: 'rewards_prod__acko__life',
      travel: 'rewards_prod__acko__travel',
      ackoDrive: 'rewards_prod__acko__ackodrive',
      ackoDriveService: 'rewards_prod__acko__ackodriveservice',
    },
    assetRewardIds: {
      [ClientName.CAR]: ['24bdaad6-1d03-480d-b2f2-8497b5881d66'],
    },
  },
  'pre-prod': {
    rewardClientNames: {
      health: 'rewards_prod__acko__health',
      car: 'rewards_prod__acko__auto',
      bike: 'rewards_prod__acko__auto',
      life: 'rewards_prod__acko__life',
      travel: 'rewards_prod__acko__travel',
      ackoDrive: 'rewards_prod__acko__ackodrive',
      ackoDriveService: 'rewards_prod__acko__ackodriveservice',
    },
    assetRewardIds: {
      [ClientName.CAR]: ['24bdaad6-1d03-480d-b2f2-8497b5881d66'],
    },
  },
}
